<div class="page-wrapper">
    <app-bees-header></app-bees-header>
    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div><!-- /.sticky-header__content -->
    </div><!-- /.stricky-header -->



    <!--Page Header Start-->
    <section class="page-header">
        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>
        <div class="container">
            <div class="page-header__inner">
                <div class="page-header__img-1">
                    <img src="assets/images/resources/page-header-img-1.png" alt="">
                </div>
                <div class="page-header__shape-1 float-bob-y">
                    <img src="assets/images/shapes/page-header-shape-1.png" alt="">
                </div>
                <h3>Contact</h3>
                <div class="thm-breadcrumb__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <li><a href="index.html">Home</a></li>
                        <li><span class="fas fa-angle-right"></span></li>
                        <li>Contact</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <!--Page Header End-->

    <!--Contact Info Start-->
    <section class="contact-info">
        <div class="container">
            <div class="row">
                <!--Contact Two Single Start-->
                <div class="col-xl-3 col-lg-6 wow fadeInLeft" data-wow-delay="100ms">
                    <div class="contact-info__single">
                        <div class="contact-info__icon">
                            <span class="icon-phone-call"></span>
                        </div>
                        <p>Contact Us</p>
                        <h5><a href="tel:09994501750">+91 999 450 1750</a></h5>
                        <h5><a href="tel:09786911750">+91 978 691 1750</a></h5>
                    </div>
                </div>
                <!--Contact Two Single End-->
                <!--Contact Two Single Start-->
                <div class="col-xl-3 col-lg-6 wow fadeInUp" data-wow-delay="200ms">
                    <div class="contact-info__single">
                        <div class="contact-info__icon">
                            <span class="icon-email"></span>
                        </div>
                        <p>Mail Us</p>
                        <h5><a
                                href="mailto:thanvikaenterprises25&#64;gmail.com">thanvikaenterprises25<br>&#64;gmail.com</a>
                        </h5>

                    </div>
                </div>
                <!--Contact Two Single End-->
                <!--Contact Two Single Start-->
                <div class="col-xl-3 col-lg-6 wow fadeInRight" data-wow-delay="300ms">
                    <div class="contact-info__single">
                        <div class="contact-info__icon">
                            <span class="icon-24-hours-service"></span>
                        </div>
                        <p>Working Hours</p>
                        <h5>Monday - Friday
                            <br> 9:00 AM - 7:00 PM
                        </h5>
                    </div>
                </div>
                <!--Contact Two Single End-->
                <!--Contact Two Single Start-->
                <div class="col-xl-3 col-lg-6 wow fadeInRight" data-wow-delay="400ms">
                    <div class="contact-info__single">
                        <div class="contact-info__icon">
                            <span class="icon-location1"></span>
                        </div>
                        <p>Our Office Location</p>
                        <h5>Bodipatti, Udumalaipettai - 642154.
                        </h5>
                    </div>
                </div>
                <!--Contact Two Single End-->
            </div>
        </div>
    </section>
    <!--Contact Info End-->

    <!--Contact Page Start-->
    <section class="contact-page">
        <div class="container">
            <div class="contact-page__inner">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="contact-page__left">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.2059266386186!2d77.23824027570171!3d10.563052663091822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9cd95bd0d849d%3A0xd4785f5e705e006d!2sTHANVIKA%20ENTERPRISES!5e0!3m2!1sen!2sin!4v1780665058219!5m2!1sen!2sin"
                                width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="contact-page__right">


                            <h2 class="contact-page__form-title">Contact Us</h2>
                            <form class="contact-form-validated contact-page__form"
                                [formGroup]="ContactFrm" (ngSubmit)="feedback()">
                                <div class="row">
                                    <div class="col-xl-6 col-lg-6 col-md-6">
                                        <div class="contact-page__input-box">
                                            <input type="text" name="name" placeholder="Your name" formControlName="name">
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6">
                                        <div class="contact-page__input-box">
                                            <input type="email" name="email" placeholder="Your Email" formControlName="email">
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-md-12">
                                        <div class="contact-page__input-box">
                                            <input type="text" placeholder="Phone" name="phone" formControlName="phone_number">
                                        </div>
                                    </div>
                                    
                                    <div class="col-xl-12">
                                        <div class="contact-page__input-box text-message-box">
                                            <textarea name="message" placeholder="Messege" required="" formControlName="message"></textarea>
                                        </div>
                                        <div class="contact-page__btn-box">
                                            <button type="submit" class="footer-widget__newsletter-btn thm-btn">Send Enquery
                                                
                                                <span><i class="icon-right-arrow"></i></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="result"></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Contact Page End-->

    <app-bees-footer></app-bees-footer>





</div><!-- /.page-wrapper -->